import { ClipLoader } from 'react-spinners'
import { useLoading } from './contexts/LoadingContext'

export default function LoadingSpinner() {
  const { isLoading } = useLoading()

  if (!isLoading) return null

  return (
    <div className="fixed inset-0 w-screen h-screen bg-white/70 flex items-center justify-center z-[999999] pointer-events-auto">
        <ClipLoader color="var(--sp-green-1)" size={60} />
    </div>
  )
}